/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Mzs_Course9Inputs */

const en__field_enum_mzs_course9 = /** @type {(inputs: _Field_Enum_Mzs_Course9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`course/teacher`)
};

const de__field_enum_mzs_course9 = /** @type {(inputs: _Field_Enum_Mzs_Course9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehrveranstaltung/Lehrende`)
};

/**
* | output |
* | --- |
* | "course/teacher" |
*
* @param {_Field_Enum_Mzs_Course9Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_mzs_course9 = /** @type {((inputs?: _Field_Enum_Mzs_Course9Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Mzs_Course9Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_mzs_course9(inputs)
	return de__field_enum_mzs_course9(inputs)
});
export { _field_enum_mzs_course9 as "_field_enum_MZS_COURSE" }